import * as types from '../store/types';
import resources from '../helpers/resources';
import select from '../store/selectors';

const client = resources();

export function setInvoice({ id, method, url, data }) {
  return {
    type: types.INVOICE_CREATED,
    payload: {
      id,
      method,
      url,
      data,
    },
  };
}

export function createInvoice(pwId, addOns = {}) {
  return async (dispatch, getState) => {
    const selector = select(getState());

    const { description, addOns: paymentAddOns } = selector.getPayment();

    const resp = await client.createInvoice(pwId, {
      ...paymentAddOns,
      description,
      ...addOns,
    });

    dispatch(setInvoice(resp.data));

    return resp;
  };
}

export function initInvoiceResult(result) {
  return {
    type: types.INIT_INVOICE_RESULT,
    payload: result,
  };
}

export function setInvoiceStatus(status) {
  return {
    type: types.SET_INVOICE_STATUS,
    payload: status,
  };
}

export function fetchInvoiceStatus() {
  return async (dispatch, getState) => {
    const selector = select(getState());

    const {
      result: { data },
    } = selector.getInvoice();

    if (data == null || data.id == null) {
      throw new Error('Cannot find invoice id');
    }

    const resp = await client.getInvoiceStatus(data.id);

    dispatch(setInvoiceStatus(resp.data));

    return resp;
  };
}
